import React from "react";
import Select from "react-dropdown-select";
import styled from "styled-components";
// components
import contentRenderer from "./ContentRenderer";
import dropDownRenderer from "./DropDownRenderer";

const SelectStyles = styled.div`
  width: 100%;

  .select {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    height: ${({ height }) => height};
    min-height: ${({ height }) => height};
    max-height: ${({ height }) => height};
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    box-shadow: none !important;
    padding: ${({ theme }) => theme.spacing[8]};
    width: 100%;
    outline: none;
    resize: none;
    position: relative;
    transition: border-color 0.15s ease, background 0.15s ease;
  }

  .selected {
  }

  .select:focus {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .select:hover {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }

  .react-dropdown-select-dropdown-handle {
    display: none;
  }

  .react-dropdown-select-dropdown {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    box-shadow: ${({ theme }) => theme.shadows.card};
    border-radius: ${({ theme }) => theme.radius[8]};
    padding: 12px;
  }

  .unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;

const optionsPlaceholder = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" }
];

const CustomSelect = ({
  touched,
  error,
  placeholder,
  size,
  src,
  withImage = false,
  isCircle,
  dropdownPosition = "auto",
  searchable = false,
  value,
  options = optionsPlaceholder,
  onChange,
  handleTouched,
  valueKey = "id",
  labelKey = "name",
  Icon,
  clearable,
  className,
  alwayClearInput = false,
  shouldHaveError = true,
  disabled
}) => {
  return (
    <SelectStyles>
      <Select
        className={`select ${value && "selected"} ${className} ${
          touched && error && "error"
        }`}
        valueKey={valueKey}
        labelKey={labelKey}
        options={options}
        values={options.filter(option => option.value == value)}
        contentRenderer={contentRenderer}
        dropdownRenderer={dropDownRenderer}
        placeholder={placeholder}
        size={size}
        src={src}
        onDropdownOpen={handleTouched}
        backspaceDelete={false}
        withImage={withImage}
        Icon={Icon}
        clearable={clearable}
        isCircle={isCircle}
        dropdownPosition={dropdownPosition}
        searchable={searchable}
        onChange={onChange}
        alwayClearInput={alwayClearInput}
        disabled={disabled}
      />
      {shouldHaveError && (
        <p className="errorMessage">{touched && error && error}</p>
      )}
    </SelectStyles>
  );
};

export default CustomSelect;
